/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable no-loop-func */
// @ts-nocheck
import { useEffect, useReducer, useRef, useState } from 'react'
import {
  Form,
  Input,
  InputNumber,
  Button,
  DatePicker,
  Row,
  Col,
  Table,
  message,
  Select,
  Checkbox,
  Space,
} from 'antd'
import {
  CalendarOutlined,
  CloseCircleOutlined,
  PlusCircleOutlined,
  MinusCircleOutlined,
} from '@ant-design/icons'
import Style from './search.module.scss'
import { GetLocalStorage, getSupplierId } from '../../tools/util'
import CustomModal from '../ModalUser'
import CustomeIcon from '../IconUser'
import { useLocation } from 'react-router-dom'
import {
  formName,
  EventNameType,
  ItemParam,
  FormItemData,
  Hidden,
  DateTime,
  SchemeType,
  SelectCheckBox,
  startTimeStampArr,
  endTimeStampArr,
  ScreenKey,
  SizeQueryList,
} from './formItem'
import moment from 'moment'
import { FormInstance } from 'antd/lib/form'
import imgUpdate from './filter_update.png'
import imgDelete from './filter_delete.png'
import {
  GET_SCHEME_LIST,
  POST_ADD_SCHEME,
  POST_DELETE_SCHEME,
  GET_SCHEME_DETAIL,
  POST_UPDATE_SCHEME,
  POST_SET_DEFAULT,
} from '../../api/schemeApi'
import { CheckCircleOutlined } from '@ant-design/icons'
import locale from 'antd/lib/date-picker/locale/zh_CN'
import 'moment/locale/zh-cn'
import { getTemplateData } from './TemplateData'
import { stopAllPropagation } from '@/tools/event'
import SizeQuery from '../SizeQuery'

import { cloneDeep, omit } from 'lodash'

moment.locale('zh-cn')

export type SearchItemFilter = {
  [x in formName]?: any
}

const ACTION_TYPE = {
  SWITCH_VISIBLE: 'SEARCH/SWITCH_VISIBLE', // 控制弹窗显示隐藏
  SET_FILTERDATA: 'SET_FILTERDATA', // 设置筛选下拉内容
  SET_COLKEY: 'SET_COLKEY', // 设置col的展示内容
  SET_SCHEMELIST: 'SET_SCHEMELIST', // 设置方案列表
  SET_ADD_FILTERDATA: 'SET_ADD_FILTERDATA', // 新增方案时候选择的筛选项列表
  SET_TABLE_TITLE: 'SET_TABLE_TITLE', // 设置筛选方案弹窗
  SET_CONFIRM_VISIBLE: 'SET_CONFIRM_VISIBLE',
  SET_DELETE_SCHEMEID: 'SET_DELETE_SCHEMEID',
  SET_SCHEME_ID: 'SET_SCHEME_ID',
  READ_CACHE_DATA: 'READ_CACHE_DATA', // 读取缓存
}
export interface schemeObj {
  id: string
  title: string
  isDefault: boolean
  isSelect: boolean
}

interface State {
  visible: boolean
  confirmVisible: boolean
  formSelectList: any[]
  showColKey: string
  showColKeyDes: string
  schemeList: schemeObj[]
  addSchemeList: any[]
  tableTitle: string
  deleteSchemeId: string
  schemeId: string
}
const defaultState: State = {
  visible: false,
  confirmVisible: false,
  formSelectList: [],
  showColKey: '',
  showColKeyDes: '',
  schemeList: [
    {
      id: 'default',
      title: '缺省',
      isDefault: false,
      isSelect: true,
    },
  ],
  addSchemeList: [],
  tableTitle: '',
  deleteSchemeId: '',
  schemeId: '',
}
const reducer = (
  state = defaultState,
  action: { type: string; value?: any },
) => {
  let arr = { ...state }
  switch (action.type) {
    case ACTION_TYPE.SWITCH_VISIBLE:
      arr.visible = action.value
      return arr
    case ACTION_TYPE.SET_FILTERDATA:
      arr.formSelectList = action.value
      return arr
    case ACTION_TYPE.SET_COLKEY:
      arr.showColKey = action.value.key
      arr.showColKeyDes = action.value.des
      return arr
    case ACTION_TYPE.SET_SCHEMELIST:
      arr.schemeList = action.value
      return arr
    case ACTION_TYPE.SET_ADD_FILTERDATA:
      arr.addSchemeList = action.value
      return arr
    case ACTION_TYPE.SET_TABLE_TITLE:
      arr.tableTitle = action.value
      return arr
    case ACTION_TYPE.SET_CONFIRM_VISIBLE:
      arr.confirmVisible = action.value
      return arr
    case ACTION_TYPE.SET_DELETE_SCHEMEID:
      arr.deleteSchemeId = action.value
      return arr
    case ACTION_TYPE.SET_SCHEME_ID:
      arr.schemeId = action.value
      return arr
    case ACTION_TYPE.READ_CACHE_DATA:
      arr = action.value
      return arr
    default:
      return arr
  }
}

const setSwitchVisibleAction = (param: boolean) => ({
  type: ACTION_TYPE.SWITCH_VISIBLE,
  value: param,
})

// 设置筛选条件
const setFormSelectListAction = (param: any[]) => ({
  type: ACTION_TYPE.SET_FILTERDATA,
  value: param,
})
// 设置col
const setColKeyAction = (param: { key: string; des: string }) => ({
  type: ACTION_TYPE.SET_COLKEY,
  value: param,
})
// 设置方案列表
const setSchemeDataAction = (param: schemeObj[]) => ({
  type: ACTION_TYPE.SET_SCHEMELIST,
  value: param,
})
// 设置筛选条件
const setAddFilterSchemeListAction = (param: any[]) => ({
  type: ACTION_TYPE.SET_ADD_FILTERDATA,
  value: param,
})
// 设置方案标题
const setTableTitleAction = (param: string) => ({
  type: ACTION_TYPE.SET_TABLE_TITLE,
  value: param,
})
const setConfirmVisibleAction = (param: boolean) => ({
  type: ACTION_TYPE.SET_CONFIRM_VISIBLE,
  value: param,
})
const setSchemeIdAction = (param: string) => ({
  type: ACTION_TYPE.SET_DELETE_SCHEMEID,
  value: param,
})
const setSchemeIdStringAction = (param: string) => ({
  type: ACTION_TYPE.SET_SCHEME_ID,
  value: param,
})

// 读取缓存

interface mod {
  key: string
  list: formName[]
}

export interface OnSearchOption {
  // 重置时传参
  isReset?: boolean
}
interface Props {
  keyName: ScreenKey // 唯一标识
  fieldsData?: formName[] // 筛选条件
  onSearch?: (e: SearchItemFilter, options?: OnSearchOption) => void // 搜索方法
  resetState?: boolean // 状态改变重置表单
  ScreenKey?: ScreenKey // 筛选模块唯一标识
  ScreenOnlyKey?: formName // 筛选模块必选条件
  currentRef?: any // from
  hideScheme?: boolean // 隐藏方案模块
  onDefaultSearch?: (e: SearchItemFilter) => void
  /** 初始化时把左侧「条件」切到该字段（如 overdueType），否则对应 Form.Item 未挂载无法赋值 */
  initialFilterFieldKey?: formName
  /** 与 initialFilterFieldKey 配合写入搜索表单（如 { overdueType: '1' }） */
  syncFormValues?: Record<string, unknown>
}

// 列表数据 检索组件
const Search = (props: Props) => {
  const {
    fieldsData,
    onSearch,
    currentRef,
    resetState,
    ScreenKey,
    keyName,
    hideScheme,
    onDefaultSearch,
    initialFilterFieldKey,
    syncFormValues,
  } = props
  const [state, dispatch] = useReducer(reducer, defaultState)
  const {
    deleteSchemeId,
    visible,
    confirmVisible,
    formSelectList,
    showColKey,
    showColKeyDes,
    schemeList,
    addSchemeList,
    tableTitle,
    schemeId,
  } = state
  const [form] = Form.useForm()
  const [form_scheme] = Form.useForm()
  const location = useLocation<{ init?: string }>()
  const contentRef = useRef<HTMLDivElement>(null)
  const dateFormat = 'YYYY-MM-DD'
  const [defaultSchemeId, setDefaultSchemeIdAction] = useState<any>('')
  const [templateData, setTemplateData] = useState({}) as any

  async function loadTemplateData() {
    const template = getTemplateData()
    setTemplateData(template)
  }
  useEffect(() => {
    loadTemplateData()
  }, [keyName])

  useEffect(() => {
    // 初始化 form
    getScreenlist()
    // 获取方案列表
    getSchemeList(false)

    // 初始化标识
    const { init } = location.state || {}
    if (init) {
      form.resetFields()
      form_scheme.resetFields()
    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    if (resetState) {
      form.resetFields()
    }
    // eslint-disable-next-line
  }, [resetState])

  useEffect(() => {
    if (defaultSchemeId) {
      if (onSearch) {
        onSearch(
          hideScheme
            ? {}
            : {
                // 有默认方案时，若查询全部数据schemeId 传 'all'
                schemeId:
                  defaultSchemeId === 'default' ? 'all' : defaultSchemeId,
              },
        )
      }
    }
    // eslint-disable-next-line
  }, [defaultSchemeId])

  useEffect(() => {
    if (!initialFilterFieldKey || formSelectList.length === 0) return
    const list = FormItemData(keyName).filter(
      (item) => item.name === initialFilterFieldKey,
    )
    if (list.length !== 1) return
    const item = list[0]
    if (item.type === DateTime) return
    const displayTitle =
      (item.moduleTitle && keyName && item.moduleTitle[keyName]) || item.title
    dispatch(
      setColKeyAction({
        key: item.name,
        des: displayTitle,
      }),
    )
  }, [initialFilterFieldKey, formSelectList.length, keyName])

  useEffect(() => {
    if (!syncFormValues || Object.keys(syncFormValues).length === 0) return
    if (
      'overdueType' in syncFormValues &&
      showColKey !== 'overdueType'
    ) {
      return
    }
    form.setFieldsValue(syncFormValues)
  }, [syncFormValues, showColKey, form])

  // 获取 筛选模块数据
  const getScreenlist = () => {
    const data: mod[] = GetLocalStorage('MDM_FILTER_SEARCH')
    let newdata = fieldsData || []
    if (data && data.length > 0) {
      const mod = data.filter((item) => item.key === ScreenKey)
      if (mod.length === 1) {
        newdata = mod[0].list
      }
    }
    const selectList: any[] = []
    // 根据传入的内容去展示下拉框
    let showColKey = ''
    let showColKeyDes = ''
    newdata.forEach((key, index) => {
      const list = FormItemData(keyName).filter((item) => item.name === key)
      if (list.length === 0) {
        const timearr = FormItemData(keyName).filter(
          (item) => item.endTimeName === key,
        )
        if (timearr.length > 0) {
          const item = timearr[0]
          item.title =
            (item.moduleTitle && item.moduleTitle[keyName]) || item.title
          selectList.push({ key: item.hiddenName, value: item.title })
          if (showColKey === '') {
            showColKey = item.endTimeName ? item.endTimeName : ''
            showColKeyDes = item.title ? item.title : ''
          }
        }
      } else {
        const item = list[0]
        item.title =
          (item.moduleTitle && item.moduleTitle[keyName]) || item.title
        selectList.push({ key: item.name, value: item.title })
        if (index === 0) {
          showColKey = item.name ? item.name : ''
          showColKeyDes = item.title ? item.title : ''
        }
      }
    })
    // 根据传入的内容获取当前模块下拉框展示内容
    dispatch(setFormSelectListAction(selectList))
    // dispatch(setAddFilterSchemeListAction(selectList))
    // 旁边的col选择默认为第一个选项 20210528下午17:26
    dispatch(setColKeyAction({ key: showColKey, des: showColKeyDes }))
  }
  // 获取方案列表  从服务器获取方案列表进行展示
  const getSchemeList = async (searchFlag: boolean, selectName?: string) => {
    const typeData = SchemeType.filter((item) => item.title === keyName)
    const resData = await GET_SCHEME_LIST({
      supplierUserId: getSupplierId(),
      type: typeData[0].type,
    })
    if (resData.code === 0) {
      // 缺省按钮选中标识
      let selectFlag = false
      const schemeData = resData.data.map((item: any) => {
        // 设置选中方案标识校验 1、如果没有selectName，则根据是否有默认方案进行选中，2、如果有selectName，则判断selectName
        let tempSelectFalg = false
        if (selectName) {
          if (selectName === item.name) {
            selectFlag = true
            tempSelectFalg = true
            setDefaultSchemeIdAction(item.id)
            // onSearch && onSearch({ schemeId: item.id })
          }
        } else {
          if (item.isDefault === '1') {
            selectFlag = true
            tempSelectFalg = true
            // 删除当前方案时，若有默认方案则跳转到默认方案
            setDefaultSchemeIdAction(item.id)
          } else {
            onDefaultSearch?.({
              schemeId: 'all',
            })
          }
        }
        return {
          id: item.id,
          title: item.name,
          isDefault: item.isDefault === '1' ? true : false,
          // isSelect:isSelect ? true : item.isDefault === '1' ? true : false,
          isSelect: tempSelectFalg,
        }
      })
      // 删除当前方案后需要重新查询全部数据
      if (searchFlag && !selectFlag) {
        // 全部数据
        setDefaultSchemeIdAction('default')
      }
      if (!searchFlag && !selectFlag) {
        onDefaultSearch?.({
          schemeId: 'all',
        })
      }
      dispatch(
        setSchemeDataAction([
          ...[
            {
              id: 'default',
              title: '缺省',
              isDefault: false,
              isSelect: !selectFlag,
            },
          ],
          ...schemeData,
        ]),
      )
    }
  }
  const filterFormItem = (key: any) => {
    const list = FormItemData(keyName).filter((item) =>
      item.type === DateTime ? item.hiddenName === key : item.name === key,
    )
    if (list.length > 0) {
      const filterObj = list[0]
      // 应用 moduleTitle 来覆盖默认 title
      const displayTitle =
        (filterObj.moduleTitle && keyName && filterObj.moduleTitle[keyName]) ||
        filterObj.title
      if (filterObj.type === DateTime) {
        return { key: filterObj.endTimeName, des: displayTitle }
      } else {
        return { key: filterObj.name, des: displayTitle }
      }
    }
    return { key: '', des: '' }
  }

  function getSearchValue(formValues: any) {
    const result = cloneDeep(formValues)

    // 收集特殊字段集中处理
    const specialItems = []
    for (const i in result) {
      result[i] = result[i] === undefined ? '' : result[i]
      if (result[i] instanceof moment) {
        result[i] = moment(result[i]).format('YYYY-MM-DD')
      }
      if (startTimeStampArr.includes(i as formName) && result[i]) {
        result[i] = Number(moment(result[i]).startOf('day').format('x'))
      }
      if (endTimeStampArr.includes(i as formName) && result[i]) {
        result[i] = Number(moment(result[i]).endOf('day').format('x'))
      } else if (SelectCheckBox.includes(i)) {
        // 如果为供应商性质的多选条件
        if (typeof result[i][0] === 'string') {
          // 将数组的时间变成空
          result[i] = result[i].join(',')
        }
      } else if (result[i] instanceof Array) {
        // 将数组的时间变成空
        result[i] = []
      }

      const item: any =
        SizeQueryList(keyName).filter((item) => item.name === i) ?? []
      if (item.length > 0) {
        const specialItem = item?.[0]
        specialItems.push(specialItem)
      }
    }

    excuteSpecialItem(specialItems, result)

    // 筛选当前的schemeId ，即当前应用的方案
    const schemeInfo = schemeList.filter((item) => item.isSelect)
    if (schemeInfo.length > 0) {
      const currentScheme = schemeInfo?.[0]
      result['schemeId'] =
        currentScheme?.id === 'default' ? 'all' : currentScheme?.id
    }

    return result
  }

  /**
   * @description: 搜索表单触发搜索操作
   * @param {any} values
   * @return {*}
   */
  const onHandleSearch = (values: any) => {
    const searchValues = getSearchValue(values)
    // 提交搜索条件
    if (onSearch) {
      onSearch(searchValues)
    }
  }
  const onHandleReset = () => {
    // 重置输入框
    const options = { isReset: true }
    form.resetFields()
    if (hideScheme) {
      onSearch?.({}, options)
      return
    }
    // 有选择筛选方案，重置时不清空筛选方案
    if (
      onSearch &&
      schemeList.some((item) => item.id === 'default' && item.isSelect)
    ) {
      if (schemeList.some((item) => item.isDefault)) {
        onSearch({ schemeId: 'all' }, options)
      } else {
        onSearch({}, options)
      }
    } else {
      onSearch?.({}, options)
    }
  }

  // 点击日期范围
  const onChangeRangepicker = (
    formatString: [string, string],
    starttimeName: formName,
    endtimeName: formName,
    currentForm: FormInstance,
  ) => {
    // 设置时间
    currentForm.setFieldsValue({
      [starttimeName]: formatString[0],
      [endtimeName]: formatString[1],
    })
  }

  // 点击清除单个数据
  const onClickdel = (e: ItemParam, currentForm: FormInstance) => {
    const hiddenName = e.hiddenName ? e.hiddenName : ''
    const name = e.name ? e.name : ''
    currentForm.resetFields([hiddenName, name])
  }

  // 获取静态数据
  const getPublicTableData = (event?: EventNameType) => {
    const index = event ? event : 'contractStatus'
    const f = templateData[index]
    if (f) {
      return f()
    }
    return {
      current: 1,
      total: 0,
      data: [],
    }
  }

  // 关闭筛选弹窗
  const onCancel = () => {
    const action = setSwitchVisibleAction(false)
    // 重置方案表单
    form_scheme.resetFields()
    dispatch(action)
    dispatch(setConfirmVisibleAction(false))
  }

  // 选中当前行数据

  // 选中筛选项

  // 展开收起
  // 新增方案
  function onAddSchemeAction() {
    if (schemeList.length === 11) {
      message.warning('方案最大数为10个')
      return
    }
    // 每次新增 重置上次输入的内容
    form_scheme.resetFields()
    dispatch(setSchemeIdStringAction(''))
    dispatch(setAddFilterSchemeListAction([{}]))
    dispatch(setTableTitleAction('筛选方案'))
    dispatch(setSwitchVisibleAction(true))
  }

  // 新增行
  function onAddLine() {
    dispatch(setAddFilterSchemeListAction([...addSchemeList, {}]))
  }
  // 删除行
  function onDeleteLine(index: number) {
    const tempList = addSchemeList
    tempList.splice(index, 1)
    dispatch(setAddFilterSchemeListAction([...tempList]))
  }
  // 删除方案
  async function onClickDelScheme(param: string) {
    dispatch(setSchemeIdAction(param))
    dispatch(setConfirmVisibleAction(true))
  }
  /**
   * @description: 删除方案，如果当前选中方案即为删除方案，则删除之后需要查询全部数据
   * @return {*}
   */
  const onConfirmDeleteScheme = async () => {
    const resData = await POST_DELETE_SCHEME({ id: deleteSchemeId })
    if (resData.code === 0) {
      message.success('删除成功')
      getSchemeList(true)
      dispatch(setConfirmVisibleAction(false))
    }
  }
  /**
   * @description: 选中方案，进行搜索
   * @param {schemeObj} param
   * @return {*}
   */
  function onClickSelectScheme(param: schemeObj) {
    // 重置输入框
    form.resetFields()
    const tempSchemeList = schemeList.map((item: schemeObj) => {
      item.id === param.id ? (item.isSelect = true) : (item.isSelect = false)
      return item
    })
    dispatch(setSchemeDataAction(tempSchemeList))
    if (param.id !== 'default') {
      if (defaultSchemeId === param.id) {
        onHandleSearch({})
      } else {
        setDefaultSchemeIdAction(param.id)
      }
    } else {
      setDefaultSchemeIdAction('default')
    }
  }

  /**
   * @description: 点击设为默认按钮操作
   * @return {*}
   */
  async function onSetDefaultSchemeAction() {
    const selectSchemeObj = schemeList.filter((item) => item.isSelect)
    if (selectSchemeObj.length > 0 && selectSchemeObj[0].id === 'default') {
      message.warning('缺省不能设置为默认')
      return
    }
    if (selectSchemeObj.length > 0 && selectSchemeObj[0].id !== 'default') {
      const resData = await POST_SET_DEFAULT({
        id: selectSchemeObj[0].id,
      })
      if (resData.code === 0) {
        message.success(`${resData.msg}`)
        // 重新获取方案信息
        getSchemeList(false)
      }
    }
  }

  // 对特殊值处理
  function excuteSpecialItem(specialItems: any[], newValues: any) {
    specialItems.forEach((item: any) => {
      const { name } = item
      if (item.type === 'SizeQuery') {
        if (item?.sizeQuery?.operatorName) {
          newValues[item?.sizeQuery?.operatorName] = newValues[name]?.operator
        }
        if (item?.sizeQuery?.numName) {
          newValues[item?.sizeQuery?.numName] = newValues[name]?.num
        }
      }
    })
  }

  // 保存方案
  const onHandleSave = async (values: any) => {
    // 收集特殊字段集中处理
    let specialItems = []

    for (const i in values) {
      values[i] = values[i] === undefined ? '' : values[i]
      if (values[i] instanceof moment) {
        values[i] = moment(values[i]).format('YYYY-MM-DD')
      }
      if (startTimeStampArr.includes(i as formName) && values[i]) {
        values[i] = Number(moment(values[i]).startOf('day').format('x'))
      }
      if (endTimeStampArr.includes(i as formName) && values[i]) {
        values[i] = Number(moment(values[i]).endOf('day').format('x'))
      }
      if (SelectCheckBox.includes(i)) {
        values[i] = values[i].join(',')
      }
      const item: any =
        SizeQueryList(keyName).filter((item) => item.name === i) ?? []
      if (item.length > 0) {
        const specialItem = item?.[0]
        specialItems.push(specialItem)
      }
    }

    excuteSpecialItem(specialItems, values)

    // 提交方案结果
    let valueKeyCount = 0
    valueKeyCount += values.length
    if (valueKeyCount < 3) {
      message.warning('方案内容不能为空')
      return
    }
    // 关闭弹窗
    dispatch(setSwitchVisibleAction(false))
    // 重置方案表单
    form_scheme.resetFields()
    // 方案类型
    const typeData = SchemeType.filter((item) => item.title === keyName)

    const sendData = {
      content: JSON.stringify(values),
      name: values.schemeName,
      supplierUserId: getSupplierId(),
      type: typeData[0].type,
      isDefault: values.isDefault ? '1' : '0',
      // id:schemeId,
    }
    const resData =
      schemeId === ''
        ? await POST_ADD_SCHEME(sendData)
        : await POST_UPDATE_SCHEME({ ...sendData, id: schemeId })
    if (resData.code === 0) {
      message.success(`${resData.msg}`)
      getSchemeList(false, values.schemeName)
      // 更新方案后刷新
      if (schemeId && onSearch) {
        onSearch({ schemeId })
      }
    }
  }

  // 修改方案详情
  async function onEditSchemeAciton(param: string) {
    const tempList: any = []
    const temp_value: any = []
    const resData = await GET_SCHEME_DETAIL({ schemeId: param })
    if (resData.code === 0) {
      if (resData.data.content.length > 0) {
        const resultList = JSON.parse(resData.data.content)
        for (let pKey in resultList) {
          // 遍历json对象的每个key/value对,p为key
          let valueTitle = ''
          const textArray = FormItemData(keyName).filter(
            (item) => item.name === pKey,
          )
          if (textArray.length > 0) {
            // 文本内容
            const textInfo = textArray[0]
            valueTitle = textInfo?.moduleTitle?.[keyName] || textInfo.title

            if (textInfo?.type === 'SizeQuery') {
              let num = resultList?.[textInfo?.sizeQuery?.numName ?? '']
              if (pKey === 'paymentProportion') {
                num = Number(num) * 100
              }
              temp_value.push({
                name: pKey,
                value: {
                  operator:
                    resultList?.[textInfo?.sizeQuery?.operatorName ?? ''],
                  num,
                },
              }) // 方案名称
            } else {
              temp_value.push({
                name: pKey,
                value: SelectCheckBox.includes(pKey)
                  ? resultList[pKey].split(',')
                  : resultList[pKey],
              }) // 方案名称
            }
          } else {
            const dateArray = FormItemData(keyName).filter(
              (item) => item.hiddenName === pKey,
            )
            if (pKey === 'createSupplierTime') {
              // 判断是否是时间格式
              valueTitle = dateArray[0].title
              pKey = dateArray[0].endTimeName ? dateArray[0].endTimeName : pKey
              const pKey2 = dateArray[0].startTimeName
                ? dateArray[0].startTimeName
                : ''
              // tempList.push({ key:pKey2, value: valueTitle, valueString: resultList[pKey2] });
              temp_value.push(
                {
                  name: dateArray[0].hiddenName,
                  value: [
                    moment(Number(resultList[pKey2])),
                    moment(Number(resultList[pKey])),
                  ],
                },
                {
                  name: pKey2,
                  value: moment(Number(resultList[pKey2])).format(dateFormat),
                },
                {
                  name: pKey,
                  value: moment(Number(resultList[pKey])).format(dateFormat),
                },
              )
              delete resultList[pKey2]
              delete resultList[pKey]
            } else if (dateArray.length > 0) {
              // 判断是否是时间格式
              valueTitle = dateArray[0].title
              pKey = dateArray[0].endTimeName ? dateArray[0].endTimeName : pKey
              const pKey2 = dateArray[0].startTimeName
                ? dateArray[0].startTimeName
                : ''
              temp_value.push(
                {
                  name: dateArray[0].hiddenName,
                  value: [moment(resultList[pKey2]), moment(resultList[pKey])],
                },
                {
                  name: pKey2,
                  value: resultList[pKey2],
                },
                {
                  name: pKey,
                  value: resultList[pKey],
                },
              )
            }
          }
          tempList.push({
            key: pKey,
            value: valueTitle,
            valueString: resultList[pKey],
          })
        }
        temp_value.push({ name: 'schemeName', value: resData.data.name }) // 方案名称
        temp_value.push({
          name: 'isDefault',
          vlaue: resData.data.isDefault === '1' ? true : false,
        }) // 是否默认

        console.log(temp_value, 'temp_value')
        const formArray = tempList.filter((item: any) => item.value !== '')
        dispatch(setAddFilterSchemeListAction(formArray))
        form_scheme.setFields(temp_value)
        form_scheme.setFieldsValue({
          isDefault: resData.data.isDefault === '1' ? true : false,
        })
        dispatch(setTableTitleAction('修改筛选方案'))
        dispatch(setSwitchVisibleAction(true))
        dispatch(setSchemeIdStringAction(param))
      }
    }
  }
  // 渲染item
  const renderFormItem = (key: string) => {
    const i = FormItemData(keyName).filter((item) => item.name === key)
    if (i.length === 0) {
      const timearr = FormItemData(keyName).filter(
        (item) => item.endTimeName === key,
      )
      if (timearr.length === 1) {
        const item = timearr[0]
        if (item.type === DateTime && item.hiddenName) {
          // 日期范围选择
          const startName = item.startTimeName
            ? item.startTimeName
            : 'contractStartDate'
          const endName = item.endTimeName
            ? item.endTimeName
            : 'contractEndDate'
          return (
            <Col {...valueColStyle} key={key}>
              <Form.Item
                name={item.hiddenName}
                {...ItemStyle}
                labelAlign="right"
              >
                <DatePicker.RangePicker
                  locale={locale}
                  getPopupContainer={() => document.body}
                  format={'YYYY-MM-DD'}
                  size="small"
                  placeholder={['请选择', '请选择']}
                  suffixIcon={<CalendarOutlined style={{ color: '#193274' }} />}
                  onChange={(value: any, formatString: [string, string]) =>
                    onChangeRangepicker(formatString, startName, endName, form)
                  }
                  {...inputStyle}
                />
              </Form.Item>
              <Form.Item
                name={item.startTimeName}
                noStyle
                style={{ display: 'none' }}
              >
                <Input hidden />
              </Form.Item>
              <Form.Item
                name={item.endTimeName}
                noStyle
                style={{ display: 'none' }}
              >
                <Input hidden />
              </Form.Item>
            </Col>
          )
        }
      }
    }
    if (i.length === 1) {
      const item = i[0]
      if (item.type === Hidden) {
        // 弹出选择数据
        const flag =
          SelectCheckBox.filter((typeItem) => typeItem === item.hiddenName)
            .length > 0
            ? true
            : false
        return (
          <Col {...valueColStyle} key={key}>
            <Form.Item name={item.hiddenName} {...ItemStyle} labelAlign="right">
              {flag ? (
                <Select
                  mode="multiple"
                  placeholder="请选择"
                  {...inputStyle}
                  allowClear
                  showSearch
                  getPopupContainer={() => document.body}
                  filterOption={(input, option: any) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  maxTagCount={2}
                  maxTagTextLength={4}
                >
                  {getPublicTableData(item.event)?.data.map((item) => (
                    <Select.Option key={item.code} value={item.code}>
                      {item.name}
                    </Select.Option>
                  ))}
                </Select>
              ) : (
                <Select
                  placeholder="请选择"
                  {...inputStyle}
                  allowClear
                  showSearch
                  getPopupContainer={() => document.body}
                  filterOption={(input, option: any) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {getPublicTableData(item.event)?.data.map((item) => (
                    <Select.Option key={item.code} value={item.code}>
                      {item.name}
                    </Select.Option>
                  ))}
                </Select>
              )}
            </Form.Item>
            <Form.Item name={item.name} noStyle style={{ display: 'none' }}>
              <Input hidden />
            </Form.Item>
          </Col>
        )
      }
      if (item.type === 'SizeQuery') {
        return (
          <Col {...valueColStyle} key={key}>
            <Form.Item name={item.name} labelAlign="right" {...ItemStyle}>
              <SizeQuery
                selectProps={{
                  getPopupContainer: () => document.body,
                  ...item?.sizeQuery?.customProps?.selectProps,
                }}
                inputProps={{
                  style: {
                    width: '100%',
                  },
                  ...item?.sizeQuery?.customProps?.InputProps,
                }}
              ></SizeQuery>
            </Form.Item>
          </Col>
        )
      }
      // 文本输入框
      return (
        <Col {...valueColStyle} key={key}>
          <Form.Item
            name={item.name}
            labelAlign="right"
            {...ItemStyle}
            getValueFromEvent={(event) =>
              event.target.value.trim()?.replace(/\s+/gi, ' ')
            }
          >
            <Input
              placeholder="请输入"
              suffix={
                <CloseCircleOutlined
                  className={Style.item}
                  onClick={() => onClickdel(item, form)}
                />
              }
              {...inputStyle}
            />
          </Form.Item>
        </Col>
      )
    }
  }
  // 渲染table 中的item
  const renderTableFormItem = (key: string, type: string, index: number) => {
    const i = FormItemData(keyName).filter((item) => item.name === key)
    if (i.length === 0) {
      const timearr = FormItemData(keyName).filter(
        (item) => item.endTimeName === key,
      )
      if (timearr.length === 1) {
        const item = timearr[0]
        if (item.type === DateTime && item.hiddenName) {
          // 日期范围选择
          const startName = item.startTimeName
            ? item.startTimeName
            : 'contractStartDate'
          const endName = item.endTimeName
            ? item.endTimeName
            : 'contractEndDate'

          return (
            <Col
              {...(type === '' ? valueColStyle : valueSchemeColStyle)}
              key={key + index.toString()}
            >
              <Form.Item
                name={item.hiddenName}
                {...ItemStyle}
                labelAlign="right"
                rules={[{ message: '请选择', required: true }]}
              >
                <DatePicker.RangePicker
                  locale={locale}
                  getPopupContainer={() => document.body}
                  format={'YYYY-MM-DD'}
                  size="small"
                  placeholder={['请选择', '请选择']}
                  suffixIcon={<CalendarOutlined style={{ color: '#193274' }} />}
                  onChange={(value: any, formatString: [string, string]) =>
                    onChangeRangepicker(
                      formatString,
                      startName,
                      endName,
                      form_scheme,
                    )
                  }
                  {...inputStyle}
                />
              </Form.Item>
              <Form.Item
                name={item.startTimeName}
                noStyle
                style={{ display: 'none' }}
              >
                <Input hidden />
              </Form.Item>
              <Form.Item
                name={item.endTimeName}
                noStyle
                style={{ display: 'none' }}
              >
                <Input hidden />
              </Form.Item>
              {renderAddOrDelete(index)}
            </Col>
          )
        }
      }
    }
    if (i.length === 1) {
      const item = i[0]
      if (item.type === Hidden) {
        // 弹出选择数据
        const flag =
          SelectCheckBox.filter((typeItem) => typeItem === item.hiddenName)
            .length > 0
            ? true
            : false

        return (
          <Col
            {...(type === '' ? valueColStyle : valueSchemeColStyle)}
            key={key + index.toString()}
          >
            <Form.Item
              name={item.hiddenName}
              {...ItemStyle}
              labelAlign="right"
              rules={[{ message: '请选择', required: true }]}
            >
              {flag ? (
                <Select
                  mode="multiple"
                  placeholder="请选择"
                  {...inputStyle}
                  allowClear
                  showSearch
                  getPopupContainer={() => document.body}
                  filterOption={(input, option: any) =>
                    option.children
                      ?.toLowerCase()
                      .indexOf(input?.toLowerCase()) >= 0
                  }
                  maxTagCount={2}
                  maxTagTextLength={4}
                >
                  {getPublicTableData(item.event)?.data.map((item) => (
                    <Select.Option key={item.code} value={item.code}>
                      {item.name}
                    </Select.Option>
                  ))}
                </Select>
              ) : (
                <Select
                  placeholder="请选择"
                  {...inputStyle}
                  allowClear
                  showSearch
                  getPopupContainer={() => document.body}
                  filterOption={(input, option: any) =>
                    option.children
                      ?.toLowerCase()
                      .indexOf(input?.toLowerCase()) >= 0
                  }
                >
                  {getPublicTableData(item.event)?.data.map((item) => (
                    <Select.Option key={item.code} value={item.code}>
                      {item.name}
                    </Select.Option>
                  ))}
                </Select>
              )}
            </Form.Item>
            <Form.Item name={item.name} noStyle style={{ display: 'none' }}>
              <Input hidden />
            </Form.Item>
            {renderAddOrDelete(index)}
          </Col>
        )
      }
      if (item.type === 'SizeQuery') {
        return (
          <Col {...valueSchemeColStyle} key={key}>
            <Form.Item name={item.name} labelAlign="right" {...ItemStyle}>
              <SizeQuery
                style={{
                  width: '100%',
                }}
                selectProps={{
                  getPopupContainer: () => document.body,
                  ...item?.sizeQuery?.customProps?.selectProps,
                }}
                inputProps={{
                  style: {
                    width: '100%',
                  },
                  ...item?.sizeQuery?.customProps?.inputProps,
                }}
              ></SizeQuery>
            </Form.Item>
            {renderAddOrDelete(index)}
          </Col>
        )
      }
      // 文本输入框
      return (
        <Col {...valueSchemeColStyle} key={key + index.toString()}>
          <Form.Item
            name={item.name}
            labelAlign="right"
            {...ItemStyle}
            getValueFromEvent={(event) =>
              event.target.value.trim()?.replace(/\s+/gi, ' ')
            }
            rules={[{ message: '请输入', required: true }]}
          >
            <Input
              placeholder="请输入"
              maxLength={50}
              suffix={
                <CloseCircleOutlined
                  className={Style.item}
                  onClick={() => onClickdel(item, form_scheme)}
                />
              }
              {...inputStyle}
            />
          </Form.Item>
          {renderAddOrDelete(index)}
        </Col>
      )
    }
    // }
  }
  function renderAddOrDelete(index: number) {
    return index === addSchemeList.length - 1 ? (
      <div style={{ position: 'absolute', right: '0px', top: '10px' }}>
        {addSchemeList.length !== formSelectList.length ? (
          <PlusCircleOutlined
            style={{ fontSize: '20px', marginRight: '10px' }}
            onClick={() => onAddLine()}
          />
        ) : null}
        {addSchemeList.length !== 1 ? (
          <MinusCircleOutlined
            style={{ fontSize: '20px', marginRight: '10px' }}
            onClick={() => onDeleteLine(index)}
          />
        ) : null}
      </div>
    ) : null
  }

  // 方案表格头
  const listColumn = [
    {
      key: 'erpCode',
      title: '筛选条件',
      onHeaderCell: () => ({
        className: Style['table-header'],
      }),
      render: (text: any, record: any, index: any) => {
        const selectListItem = addSchemeList.map((item) => item.value)
        const filteredOptions = formSelectList.filter(
          (o) => !selectListItem.includes(o.value),
        )
        return (
          <div>
            <Select
              placeholder="请选择"
              {...inputStyle}
              allowClear
              showSearch
              getPopupContainer={() => document.body}
              filterOption={(input, option: any) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              onSelect={(value: any) => {
                // 根据选择的内容更换旁边col的展示内容

                const result = filterFormItem(value)
                addSchemeList[index].key = result.key
                addSchemeList[index].value = result.des
                dispatch(setAddFilterSchemeListAction(addSchemeList))
              }}
              value={addSchemeList[index].value}
            >
              {filteredOptions.map((item) => (
                <Select.Option key={item.key} value={item.key}>
                  {item.value}
                </Select.Option>
              ))}
            </Select>
          </div>
        )
      },
    },
    {
      key: 'name',
      title: '值',
      textAlign: 'center',
      onHeaderCell: () => ({
        className: Style['table-header'],
      }),
      onCell: () => ({
        className: Style['table-td'],
      }),
      render: (text: any, record: any, index: any) => {
        return (
          <div style={{ width: '100%', display: 'flex' }}>
            {renderTableFormItem(addSchemeList[index].key, '_scheme', index)}
          </div>
        )
      },
    },
  ]

  // input 样式
  const inputStyle = {
    style: {
      height: '24px',
      lineHeight: '24px',
      fontSize: '12px',
      width: '100%',
      cursor: 'pointer',
    },
  }
  // input 样式
  // Item样式
  const ItemStyle = {
    style: { marginBottom: '0px' },
    wrapperCol: { span: 20 },
  }
  //  col 样式
  const colStyle = {
    style: { padding: '10px 5px 5px 5px' },
    xl: { span: hideScheme ? 6 : 3 }, // ≥1200px
    lg: { span: 12 }, // 大桌面显示器  ≥992px)
    md: { span: 12 }, // 桌面显示器 ≥768px)
    sm: { span: 24 }, // 平板 ≥576px
  }
  const valueColStyle = {
    style: { padding: '10px 5px 5px 5px' },
    xl: { span: hideScheme ? 8 : 6 }, // ≥1200px
    lg: { span: 12 }, // 大桌面显示器  ≥992px)
    md: { span: 12 }, // 桌面显示器 ≥768px)
    sm: { span: 24 }, // 平板 ≥576px
  }
  const valueSchemeColStyle = {
    style: { padding: '10px 5px 5px 5px' },
    xl: { span: 24 }, // ≥1200px
    lg: { span: 12 }, // 大桌面显示器  ≥992px)
    md: { span: 12 }, // 桌面显示器 ≥768px)
    sm: { span: 24 }, // 平板 ≥576px
  }
  return (
    <div>
      <Form
        // ref={currentForm}
        ref={currentRef}
        form={form}
        className={Style.searchform}
        name="searchForm"
        colon={false}
        onFinish={onHandleSearch}
      >
        <div className={Style.searchbox}>
          <div className={Style['condition-row']}>
            <div className={Style.screen}>
              <CustomeIcon
                type="icon-fangdajing"
                style={{ fontSize: '16px' }}
              />
              <span>条件:</span>
            </div>
            <div className={`${Style.content}`}>
              <div ref={contentRef}>
                <Row gutter={8} style={{ margin: '0 0 0 0' }}>
                  {/* {默认为下拉选择框，下拉数据为外部传入} */}
                  {/* <div style={{width:'160px'}}> */}
                  <Col {...colStyle}>
                    <Select
                      placeholder="请选择"
                      {...inputStyle}
                      allowClear
                      showSearch
                      getPopupContainer={() => document.body}
                      filterOption={(input, option: any) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      onSelect={(value: any) => {
                        // 根据选择的内容更换旁边col的展示内容
                        const result = filterFormItem(value)
                        dispatch(
                          setColKeyAction({
                            key: result.key ? result.key : '',
                            des: result.des,
                          }),
                        )
                      }}
                      value={showColKeyDes}
                    >
                      {formSelectList.map((item) => (
                        <Select.Option key={item.key} value={item.key}>
                          {item.value}
                        </Select.Option>
                      ))}
                    </Select>
                  </Col>
                  {renderFormItem(showColKey)}
                  <div className={Style.toolbox}>
                    <Button
                      type="primary"
                      size="small"
                      htmlType="submit"
                      style={{
                        color: '#FFFFFF',
                        background: '#3C44D3',
                        borderColor: '#3C44D3',
                        marginRight: '10px',
                      }}
                      className={Style.toolBtn}
                    >
                      查询
                    </Button>
                    <Button
                      type="primary"
                      ghost
                      size="small"
                      // htmlType="reset"
                      style={{ color: '#3C44D3', borderColor: '#3C44D3' }}
                      className={Style.toolBtn}
                      onClick={(e) => {
                        stopAllPropagation(e)
                        onHandleReset?.()
                      }}
                    >
                      重置
                    </Button>
                  </div>
                </Row>
              </div>
            </div>
          </div>
          <div className={Style['scheme-row']} hidden={hideScheme}>
            <div className={Style.screen}>
              <CustomeIcon
                type="icon-fangdajing"
                style={{ fontSize: '16px' }}
              />
              <span>方案:</span>
            </div>
            <div className={`${Style.content}`}>
              <div ref={contentRef} className={`${Style.schemeList}`}>
                {/* <Row gutter={8} style={{ margin: '0 0 0 0' }}> */}
                {schemeList.map((item: schemeObj) => (
                  <div
                    key={item.id}
                    className={`${
                      item.isSelect ? Style.defaultScheme : Style.scheme
                    }`}
                    onClick={() => onClickSelectScheme(item)}
                  >
                    {item.id !== 'default' ? (
                      <div className={Style['scheme-item']}>
                        {item.isDefault ? (
                          <CheckCircleOutlined
                            style={{
                              position: 'relative',
                              left: '-15px',
                              top: '-14px',
                            }}
                          />
                        ) : null}
                        <span className={Style['selectSpan']}>
                          {item.title}
                        </span>

                        <img
                          className={Style.spanItem}
                          src={imgDelete}
                          onClick={(event) => {
                            event.stopPropagation()
                            event.nativeEvent.stopImmediatePropagation()
                            onClickDelScheme(item.id)
                          }}
                          alt=""
                        ></img>
                        <img
                          className={Style.updateItem}
                          src={imgUpdate}
                          onClick={(event) => {
                            event.stopPropagation()
                            event.nativeEvent.stopImmediatePropagation()
                            onEditSchemeAciton(item.id)
                          }}
                          alt=""
                        ></img>
                      </div>
                    ) : (
                      <span className={Style['selectSpan']}>{item.title}</span>
                    )}
                  </div>
                ))}
                <div className={Style.toolbox}>
                  <Button
                    type="primary"
                    size="small"
                    style={{
                      color: '#3C44D3',
                      background: '#FFFFFF',
                      borderColor: '#3C44D3',
                      marginRight: '10px',
                    }}
                    onClick={onAddSchemeAction}
                    className={Style.toolBtn}
                  >
                    添加
                  </Button>
                  <Button
                    type="primary"
                    size="small"
                    style={{
                      color: '#3C44D3',
                      background: '#FFFFFF',
                      borderColor: '#3C44D3',
                    }}
                    onClick={onSetDefaultSchemeAction}
                    className={Style.toolBtn}
                  >
                    设为默认
                  </Button>
                </div>
                {/* </Row> */}
              </div>
            </div>
          </div>
        </div>
      </Form>
      <CustomModal
        width={700}
        open={visible}
        title={tableTitle}
        footer={false}
        modalCancel={onCancel}
      >
        <Form
          form={form_scheme}
          className={Style.searchform}
          colon={false}
          onFinish={onHandleSave}
          onReset={onHandleReset}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              margin: '10px 0 10px 0',
            }}
          >
            <span>方案名称：</span>
            <Form.Item
              name="schemeName"
              style={{ margin: '4px 0 0 10px' }}
              rules={[{ message: '请输入方案名称', required: true }]}
            >
              <Input
                size="small"
                placeholder="请输入"
                style={{ width: '350px' }}
                onChange={(e) =>
                  form_scheme.setFieldsValue({ schemeName: e.target.value })
                }
                maxLength={30}
              />
            </Form.Item>

            <Form.Item
              name="isDefault"
              style={{ margin: '4px 0 0 10px' }}
              valuePropName="checked"
            >
              <Checkbox>设为默认</Checkbox>
            </Form.Item>
          </div>
          <Table
            rowKey="id"
            tableLayout="fixed"
            className={Style['table-box']}
            size="small"
            dataSource={addSchemeList}
            loading={false}
            columns={listColumn}
            pagination={false}
          ></Table>
          <div
            style={{
              textAlign: 'center',
              borderTop: '1px solid #F8F8F8',
              paddingTop: '10px',
            }}
          >
            <Button
              type="primary"
              size="middle"
              htmlType="submit"
              style={{ backgroundColor: '#193274' }}
            >
              保存
            </Button>
          </div>
        </Form>
      </CustomModal>

      {/* 筛选条件 */}
      <CustomModal
        width={350}
        open={confirmVisible}
        title={'是否确定删除该方案'}
        modalCancel={onCancel}
        modalSubmit={onConfirmDeleteScheme}
      ></CustomModal>
    </div>
  )
}

export default Search
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable no-loop-func */
// @ts-nocheck
import { useEffect, useReducer, useRef, useState } from 'react'
import {
  Form,
  Input,
  InputNumber,
  Button,
  DatePicker,
  Row,
  Col,
  Table,
  message,
  Select,
  Checkbox,
  Space,
} from 'antd'
import {
  CalendarOutlined,
  CloseCircleOutlined,
  PlusCircleOutlined,
  MinusCircleOutlined,
} from '@ant-design/icons'
import Style from './search.module.scss'
import { GetLocalStorage, getSupplierId } from '../../tools/util'
import CustomModal from '../ModalUser'
import CustomeIcon from '../IconUser'
import { useLocation } from 'react-router-dom'
import {
  formName,
  EventNameType,
  ItemParam,
  FormItemData,
  Hidden,
  DateTime,
  SchemeType,
  SelectCheckBox,
  startTimeStampArr,
  endTimeStampArr,
  ScreenKey,
  SizeQueryList,
} from './formItem'
import moment from 'moment'
import { FormInstance } from 'antd/lib/form'
import imgUpdate from './filter_update.png'
import imgDelete from './filter_delete.png'
import {
  GET_SCHEME_LIST,
  POST_ADD_SCHEME,
  POST_DELETE_SCHEME,
  GET_SCHEME_DETAIL,
  POST_UPDATE_SCHEME,
  POST_SET_DEFAULT,
} from '../../api/schemeApi'
import { CheckCircleOutlined } from '@ant-design/icons'
import locale from 'antd/lib/date-picker/locale/zh_CN'
import 'moment/locale/zh-cn'
import { getTemplateData } from './TemplateData'
import { stopAllPropagation } from '@/tools/event'
import SizeQuery from '../SizeQuery'

import { cloneDeep, omit } from 'lodash'

moment.locale('zh-cn')

export type SearchItemFilter = {
  [x in formName]?: any
}

const ACTION_TYPE = {
  SWITCH_VISIBLE: 'SEARCH/SWITCH_VISIBLE', // 控制弹窗显示隐藏
  SET_FILTERDATA: 'SET_FILTERDATA', // 设置筛选下拉内容
  SET_COLKEY: 'SET_COLKEY', // 设置col的展示内容
  SET_SCHEMELIST: 'SET_SCHEMELIST', // 设置方案列表
  SET_ADD_FILTERDATA: 'SET_ADD_FILTERDATA', // 新增方案时候选择的筛选项列表
  SET_TABLE_TITLE: 'SET_TABLE_TITLE', // 设置筛选方案弹窗
  SET_CONFIRM_VISIBLE: 'SET_CONFIRM_VISIBLE',
  SET_DELETE_SCHEMEID: 'SET_DELETE_SCHEMEID',
  SET_SCHEME_ID: 'SET_SCHEME_ID',
  READ_CACHE_DATA: 'READ_CACHE_DATA', // 读取缓存
}
export interface schemeObj {
  id: string
  title: string
  isDefault: boolean
  isSelect: boolean
}

interface State {
  visible: boolean
  confirmVisible: boolean
  formSelectList: any[]
  showColKey: string
  showColKeyDes: string
  schemeList: schemeObj[]
  addSchemeList: any[]
  tableTitle: string
  deleteSchemeId: string
  schemeId: string
}
const defaultState: State = {
  visible: false,
  confirmVisible: false,
  formSelectList: [],
  showColKey: '',
  showColKeyDes: '',
  schemeList: [
    {
      id: 'default',
      title: '缺省',
      isDefault: false,
      isSelect: true,
    },
  ],
  addSchemeList: [],
  tableTitle: '',
  deleteSchemeId: '',
  schemeId: '',
}
const reducer = (
  state = defaultState,
  action: { type: string; value?: any },
) => {
  let arr = { ...state }
  switch (action.type) {
    case ACTION_TYPE.SWITCH_VISIBLE:
      arr.visible = action.value
      return arr
    case ACTION_TYPE.SET_FILTERDATA:
      arr.formSelectList = action.value
      return arr
    case ACTION_TYPE.SET_COLKEY:
      arr.showColKey = action.value.key
      arr.showColKeyDes = action.value.des
      return arr
    case ACTION_TYPE.SET_SCHEMELIST:
      arr.schemeList = action.value
      return arr
    case ACTION_TYPE.SET_ADD_FILTERDATA:
      arr.addSchemeList = action.value
      return arr
    case ACTION_TYPE.SET_TABLE_TITLE:
      arr.tableTitle = action.value
      return arr
    case ACTION_TYPE.SET_CONFIRM_VISIBLE:
      arr.confirmVisible = action.value
      return arr
    case ACTION_TYPE.SET_DELETE_SCHEMEID:
      arr.deleteSchemeId = action.value
      return arr
    case ACTION_TYPE.SET_SCHEME_ID:
      arr.schemeId = action.value
      return arr
    case ACTION_TYPE.READ_CACHE_DATA:
      arr = action.value
      return arr
    default:
      return arr
  }
}

const setSwitchVisibleAction = (param: boolean) => ({
  type: ACTION_TYPE.SWITCH_VISIBLE,
  value: param,
})

// 设置筛选条件
const setFormSelectListAction = (param: any[]) => ({
  type: ACTION_TYPE.SET_FILTERDATA,
  value: param,
})
// 设置col
const setColKeyAction = (param: { key: string; des: string }) => ({
  type: ACTION_TYPE.SET_COLKEY,
  value: param,
})
// 设置方案列表
const setSchemeDataAction = (param: schemeObj[]) => ({
  type: ACTION_TYPE.SET_SCHEMELIST,
  value: param,
})
// 设置筛选条件
const setAddFilterSchemeListAction = (param: any[]) => ({
  type: ACTION_TYPE.SET_ADD_FILTERDATA,
  value: param,
})
// 设置方案标题
const setTableTitleAction = (param: string) => ({
  type: ACTION_TYPE.SET_TABLE_TITLE,
  value: param,
})
const setConfirmVisibleAction = (param: boolean) => ({
  type: ACTION_TYPE.SET_CONFIRM_VISIBLE,
  value: param,
})
const setSchemeIdAction = (param: string) => ({
  type: ACTION_TYPE.SET_DELETE_SCHEMEID,
  value: param,
})
const setSchemeIdStringAction = (param: string) => ({
  type: ACTION_TYPE.SET_SCHEME_ID,
  value: param,
})

// 读取缓存

interface mod {
  key: string
  list: formName[]
}

export interface OnSearchOption {
  // 重置时传参
  isReset?: boolean
}
interface Props {
  keyName: ScreenKey // 唯一标识
  fieldsData?: formName[] // 筛选条件
  onSearch?: (e: SearchItemFilter, options?: OnSearchOption) => void // 搜索方法
  resetState?: boolean // 状态改变重置表单
  ScreenKey?: ScreenKey // 筛选模块唯一标识
  ScreenOnlyKey?: formName // 筛选模块必选条件
  currentRef?: any // from
  hideScheme?: boolean // 隐藏方案模块
  onDefaultSearch?: (e: SearchItemFilter) => void
  /** 初始化时把左侧「条件」切到该字段（如 overdueType），否则对应 Form.Item 未挂载无法赋值 */
  initialFilterFieldKey?: formName
  /** 与 initialFilterFieldKey 配合写入搜索表单（如 { overdueType: '1' }） */
  syncFormValues?: Record<string, unknown>
}

// 列表数据 检索组件
const Search = (props: Props) => {
  const {
    fieldsData,
    onSearch,
    currentRef,
    resetState,
    ScreenKey,
    keyName,
    hideScheme,
    onDefaultSearch,
    initialFilterFieldKey,
    syncFormValues,
  } = props
  const [state, dispatch] = useReducer(reducer, defaultState)
  const {
    deleteSchemeId,
    visible,
    confirmVisible,
    formSelectList,
    showColKey,
    showColKeyDes,
    schemeList,
    addSchemeList,
    tableTitle,
    schemeId,
  } = state
  const [form] = Form.useForm()
  const [form_scheme] = Form.useForm()
  const location = useLocation<{ init?: string }>()
  const contentRef = useRef<HTMLDivElement>(null)
  const dateFormat = 'YYYY-MM-DD'
  const [defaultSchemeId, setDefaultSchemeIdAction] = useState<any>('')
  const [templateData, setTemplateData] = useState({}) as any

  async function loadTemplateData() {
    const template = getTemplateData()
    setTemplateData(template)
  }
  useEffect(() => {
    loadTemplateData()
  }, [keyName])

  useEffect(() => {
    // 初始化 form
    getScreenlist()
    // 获取方案列表
    getSchemeList(false)

    // 初始化标识
    const { init } = location.state || {}
    if (init) {
      form.resetFields()
      form_scheme.resetFields()
    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    if (resetState) {
      form.resetFields()
    }
    // eslint-disable-next-line
  }, [resetState])

  useEffect(() => {
    if (defaultSchemeId) {
      if (onSearch) {
        onSearch(
          hideScheme
            ? {}
            : {
                // 有默认方案时，若查询全部数据schemeId 传 'all'
                schemeId:
                  defaultSchemeId === 'default' ? 'all' : defaultSchemeId,
              },
        )
      }
    }
    // eslint-disable-next-line
  }, [defaultSchemeId])

  useEffect(() => {
    if (!initialFilterFieldKey || formSelectList.length === 0) return
    const list = FormItemData(keyName).filter(
      (item) => item.name === initialFilterFieldKey,
    )
    if (list.length !== 1) return
    const item = list[0]
    if (item.type === DateTime) return
    const displayTitle =
      (item.moduleTitle && keyName && item.moduleTitle[keyName]) || item.title
    dispatch(
      setColKeyAction({
        key: item.name,
        des: displayTitle,
      }),
    )
  }, [initialFilterFieldKey, formSelectList.length, keyName])

  useEffect(() => {
    if (!syncFormValues || Object.keys(syncFormValues).length === 0) return
    if (
      'overdueType' in syncFormValues &&
      showColKey !== 'overdueType'
    ) {
      return
    }
    form.setFieldsValue(syncFormValues)
  }, [syncFormValues, showColKey, form])

  // 获取 筛选模块数据
  const getScreenlist = () => {
    const data: mod[] = GetLocalStorage('MDM_FILTER_SEARCH')
    let newdata = fieldsData || []
    if (data && data.length > 0) {
      const mod = data.filter((item) => item.key === ScreenKey)
      if (mod.length === 1) {
        newdata = mod[0].list
      }
    }
    const selectList: any[] = []
    // 根据传入的内容去展示下拉框
    let showColKey = ''
    let showColKeyDes = ''
    newdata.forEach((key, index) => {
      const list = FormItemData(keyName).filter((item) => item.name === key)
      if (list.length === 0) {
        const timearr = FormItemData(keyName).filter(
          (item) => item.endTimeName === key,
        )
        if (timearr.length > 0) {
          const item = timearr[0]
          item.title =
            (item.moduleTitle && item.moduleTitle[keyName]) || item.title
          selectList.push({ key: item.hiddenName, value: item.title })
          if (showColKey === '') {
            showColKey = item.endTimeName ? item.endTimeName : ''
            showColKeyDes = item.title ? item.title : ''
          }
        }
      } else {
        const item = list[0]
        item.title =
          (item.moduleTitle && item.moduleTitle[keyName]) || item.title
        selectList.push({ key: item.name, value: item.title })
        if (index === 0) {
          showColKey = item.name ? item.name : ''
          showColKeyDes = item.title ? item.title : ''
        }
      }
    })
    // 根据传入的内容获取当前模块下拉框展示内容
    dispatch(setFormSelectListAction(selectList))
    // dispatch(setAddFilterSchemeListAction(selectList))
    // 旁边的col选择默认为第一个选项 20210528下午17:26
    dispatch(setColKeyAction({ key: showColKey, des: showColKeyDes }))
  }
  // 获取方案列表  从服务器获取方案列表进行展示
  const getSchemeList = async (searchFlag: boolean, selectName?: string) => {
    const typeData = SchemeType.filter((item) => item.title === keyName)
    const resData = await GET_SCHEME_LIST({
      supplierUserId: getSupplierId(),
      type: typeData[0].type,
    })
    if (resData.code === 0) {
      // 缺省按钮选中标识
      let selectFlag = false
      const schemeData = resData.data.map((item: any) => {
        // 设置选中方案标识校验 1、如果没有selectName，则根据是否有默认方案进行选中，2、如果有selectName，则判断selectName
        let tempSelectFalg = false
        if (selectName) {
          if (selectName === item.name) {
            selectFlag = true
            tempSelectFalg = true
            setDefaultSchemeIdAction(item.id)
            // onSearch && onSearch({ schemeId: item.id })
          }
        } else {
          if (item.isDefault === '1') {
            selectFlag = true
            tempSelectFalg = true
            // 删除当前方案时，若有默认方案则跳转到默认方案
            setDefaultSchemeIdAction(item.id)
          } else {
            onDefaultSearch?.({
              schemeId: 'all',
            })
          }
        }
        return {
          id: item.id,
          title: item.name,
          isDefault: item.isDefault === '1' ? true : false,
          // isSelect:isSelect ? true : item.isDefault === '1' ? true : false,
          isSelect: tempSelectFalg,
        }
      })
      // 删除当前方案后需要重新查询全部数据
      if (searchFlag && !selectFlag) {
        // 全部数据
        setDefaultSchemeIdAction('default')
      }
      if (!searchFlag && !selectFlag) {
        onDefaultSearch?.({
          schemeId: 'all',
        })
      }
      dispatch(
        setSchemeDataAction([
          ...[
            {
              id: 'default',
              title: '缺省',
              isDefault: false,
              isSelect: !selectFlag,
            },
          ],
          ...schemeData,
        ]),
      )
    }
  }
  const filterFormItem = (key: any) => {
    const list = FormItemData(keyName).filter((item) =>
      item.type === DateTime ? item.hiddenName === key : item.name === key,
    )
    if (list.length > 0) {
      const filterObj = list[0]
      // 应用 moduleTitle 来覆盖默认 title
      const displayTitle =
        (filterObj.moduleTitle && keyName && filterObj.moduleTitle[keyName]) ||
        filterObj.title
      if (filterObj.type === DateTime) {
        return { key: filterObj.endTimeName, des: displayTitle }
      } else {
        return { key: filterObj.name, des: displayTitle }
      }
    }
    return { key: '', des: '' }
  }

  function getSearchValue(formValues: any) {
    const result = cloneDeep(formValues)

    // 收集特殊字段集中处理
    const specialItems = []
    for (const i in result) {
      result[i] = result[i] === undefined ? '' : result[i]
      if (result[i] instanceof moment) {
        result[i] = moment(result[i]).format('YYYY-MM-DD')
      }
      if (startTimeStampArr.includes(i as formName) && result[i]) {
        result[i] = Number(moment(result[i]).startOf('day').format('x'))
      }
      if (endTimeStampArr.includes(i as formName) && result[i]) {
        result[i] = Number(moment(result[i]).endOf('day').format('x'))
      } else if (SelectCheckBox.includes(i)) {
        // 如果为供应商性质的多选条件
        if (typeof result[i][0] === 'string') {
          // 将数组的时间变成空
          result[i] = result[i].join(',')
        }
      } else if (result[i] instanceof Array) {
        // 将数组的时间变成空
        result[i] = []
      }

      const item: any =
        SizeQueryList(keyName).filter((item) => item.name === i) ?? []
      if (item.length > 0) {
        const specialItem = item?.[0]
        specialItems.push(specialItem)
      }
    }

    excuteSpecialItem(specialItems, result)

    // 筛选当前的schemeId ，即当前应用的方案
    const schemeInfo = schemeList.filter((item) => item.isSelect)
    if (schemeInfo.length > 0) {
      const currentScheme = schemeInfo?.[0]
      result['schemeId'] =
        currentScheme?.id === 'default' ? 'all' : currentScheme?.id
    }

    return result
  }

  /**
   * @description: 搜索表单触发搜索操作
   * @param {any} values
   * @return {*}
   */
  const onHandleSearch = (values: any) => {
    const searchValues = getSearchValue(values)
    // 提交搜索条件
    if (onSearch) {
      onSearch(searchValues)
    }
  }
  const onHandleReset = () => {
    // 重置输入框
    const options = { isReset: true }
    form.resetFields()
    if (hideScheme) {
      onSearch?.({}, options)
      return
    }
    // 有选择筛选方案，重置时不清空筛选方案
    if (
      onSearch &&
      schemeList.some((item) => item.id === 'default' && item.isSelect)
    ) {
      if (schemeList.some((item) => item.isDefault)) {
        onSearch({ schemeId: 'all' }, options)
      } else {
        onSearch({}, options)
      }
    } else {
      onSearch?.({}, options)
    }
  }

  // 点击日期范围
  const onChangeRangepicker = (
    formatString: [string, string],
    starttimeName: formName,
    endtimeName: formName,
    currentForm: FormInstance,
  ) => {
    // 设置时间
    currentForm.setFieldsValue({
      [starttimeName]: formatString[0],
      [endtimeName]: formatString[1],
    })
  }

  // 点击清除单个数据
  const onClickdel = (e: ItemParam, currentForm: FormInstance) => {
    const hiddenName = e.hiddenName ? e.hiddenName : ''
    const name = e.name ? e.name : ''
    currentForm.resetFields([hiddenName, name])
  }

  // 获取静态数据
  const getPublicTableData = (event?: EventNameType) => {
    const index = event ? event : 'contractStatus'
    const f = templateData[index]
    if (f) {
      return f()
    }
    return {
      current: 1,
      total: 0,
      data: [],
    }
  }

  // 关闭筛选弹窗
  const onCancel = () => {
    const action = setSwitchVisibleAction(false)
    // 重置方案表单
    form_scheme.resetFields()
    dispatch(action)
    dispatch(setConfirmVisibleAction(false))
  }

  // 选中当前行数据

  // 选中筛选项

  // 展开收起
  // 新增方案
  function onAddSchemeAction() {
    if (schemeList.length === 11) {
      message.warning('方案最大数为10个')
      return
    }
    // 每次新增 重置上次输入的内容
    form_scheme.resetFields()
    dispatch(setSchemeIdStringAction(''))
    dispatch(setAddFilterSchemeListAction([{}]))
    dispatch(setTableTitleAction('筛选方案'))
    dispatch(setSwitchVisibleAction(true))
  }

  // 新增行
  function onAddLine() {
    dispatch(setAddFilterSchemeListAction([...addSchemeList, {}]))
  }
  // 删除行
  function onDeleteLine(index: number) {
    const tempList = addSchemeList
    tempList.splice(index, 1)
    dispatch(setAddFilterSchemeListAction([...tempList]))
  }
  // 删除方案
  async function onClickDelScheme(param: string) {
    dispatch(setSchemeIdAction(param))
    dispatch(setConfirmVisibleAction(true))
  }
  /**
   * @description: 删除方案，如果当前选中方案即为删除方案，则删除之后需要查询全部数据
   * @return {*}
   */
  const onConfirmDeleteScheme = async () => {
    const resData = await POST_DELETE_SCHEME({ id: deleteSchemeId })
    if (resData.code === 0) {
      message.success('删除成功')
      getSchemeList(true)
      dispatch(setConfirmVisibleAction(false))
    }
  }
  /**
   * @description: 选中方案，进行搜索
   * @param {schemeObj} param
   * @return {*}
   */
  function onClickSelectScheme(param: schemeObj) {
    // 重置输入框
    form.resetFields()
    const tempSchemeList = schemeList.map((item: schemeObj) => {
      item.id === param.id ? (item.isSelect = true) : (item.isSelect = false)
      return item
    })
    dispatch(setSchemeDataAction(tempSchemeList))
    if (param.id !== 'default') {
      if (defaultSchemeId === param.id) {
        onHandleSearch({})
      } else {
        setDefaultSchemeIdAction(param.id)
      }
    } else {
      setDefaultSchemeIdAction('default')
    }
  }

  /**
   * @description: 点击设为默认按钮操作
   * @return {*}
   */
  async function onSetDefaultSchemeAction() {
    const selectSchemeObj = schemeList.filter((item) => item.isSelect)
    if (selectSchemeObj.length > 0 && selectSchemeObj[0].id === 'default') {
      message.warning('缺省不能设置为默认')
      return
    }
    if (selectSchemeObj.length > 0 && selectSchemeObj[0].id !== 'default') {
      const resData = await POST_SET_DEFAULT({
        id: selectSchemeObj[0].id,
      })
      if (resData.code === 0) {
        message.success(`${resData.msg}`)
        // 重新获取方案信息
        getSchemeList(false)
      }
    }
  }

  // 对特殊值处理
  function excuteSpecialItem(specialItems: any[], newValues: any) {
    specialItems.forEach((item: any) => {
      const { name } = item
      if (item.type === 'SizeQuery') {
        if (item?.sizeQuery?.operatorName) {
          newValues[item?.sizeQuery?.operatorName] = newValues[name]?.operator
        }
        if (item?.sizeQuery?.numName) {
          newValues[item?.sizeQuery?.numName] = newValues[name]?.num
        }
      }
    })
  }

  // 保存方案
  const onHandleSave = async (values: any) => {
    // 收集特殊字段集中处理
    let specialItems = []

    for (const i in values) {
      values[i] = values[i] === undefined ? '' : values[i]
      if (values[i] instanceof moment) {
        values[i] = moment(values[i]).format('YYYY-MM-DD')
      }
      if (startTimeStampArr.includes(i as formName) && values[i]) {
        values[i] = Number(moment(values[i]).startOf('day').format('x'))
      }
      if (endTimeStampArr.includes(i as formName) && values[i]) {
        values[i] = Number(moment(values[i]).endOf('day').format('x'))
      }
      if (SelectCheckBox.includes(i)) {
        values[i] = values[i].join(',')
      }
      const item: any =
        SizeQueryList(keyName).filter((item) => item.name === i) ?? []
      if (item.length > 0) {
        const specialItem = item?.[0]
        specialItems.push(specialItem)
      }
    }

    excuteSpecialItem(specialItems, values)

    // 提交方案结果
    let valueKeyCount = 0
    valueKeyCount += values.length
    if (valueKeyCount < 3) {
      message.warning('方案内容不能为空')
      return
    }
    // 关闭弹窗
    dispatch(setSwitchVisibleAction(false))
    // 重置方案表单
    form_scheme.resetFields()
    // 方案类型
    const typeData = SchemeType.filter((item) => item.title === keyName)

    const sendData = {
      content: JSON.stringify(values),
      name: values.schemeName,
      supplierUserId: getSupplierId(),
      type: typeData[0].type,
      isDefault: values.isDefault ? '1' : '0',
      // id:schemeId,
    }
    const resData =
      schemeId === ''
        ? await POST_ADD_SCHEME(sendData)
        : await POST_UPDATE_SCHEME({ ...sendData, id: schemeId })
    if (resData.code === 0) {
      message.success(`${resData.msg}`)
      getSchemeList(false, values.schemeName)
      // 更新方案后刷新
      if (schemeId && onSearch) {
        onSearch({ schemeId })
      }
    }
  }

  // 修改方案详情
  async function onEditSchemeAciton(param: string) {
    const tempList: any = []
    const temp_value: any = []
    const resData = await GET_SCHEME_DETAIL({ schemeId: param })
    if (resData.code === 0) {
      if (resData.data.content.length > 0) {
        const resultList = JSON.parse(resData.data.content)
        for (let pKey in resultList) {
          // 遍历json对象的每个key/value对,p为key
          let valueTitle = ''
          const textArray = FormItemData(keyName).filter(
            (item) => item.name === pKey,
          )
          if (textArray.length > 0) {
            // 文本内容
            const textInfo = textArray[0]
            valueTitle = textInfo?.moduleTitle?.[keyName] || textInfo.title

            if (textInfo?.type === 'SizeQuery') {
              let num = resultList?.[textInfo?.sizeQuery?.numName ?? '']
              if (pKey === 'paymentProportion') {
                num = Number(num) * 100
              }
              temp_value.push({
                name: pKey,
                value: {
                  operator:
                    resultList?.[textInfo?.sizeQuery?.operatorName ?? ''],
                  num,
                },
              }) // 方案名称
            } else {
              temp_value.push({
                name: pKey,
                value: SelectCheckBox.includes(pKey)
                  ? resultList[pKey].split(',')
                  : resultList[pKey],
              }) // 方案名称
            }
          } else {
            const dateArray = FormItemData(keyName).filter(
              (item) => item.hiddenName === pKey,
            )
            if (pKey === 'createSupplierTime') {
              // 判断是否是时间格式
              valueTitle = dateArray[0].title
              pKey = dateArray[0].endTimeName ? dateArray[0].endTimeName : pKey
              const pKey2 = dateArray[0].startTimeName
                ? dateArray[0].startTimeName
                : ''
              // tempList.push({ key:pKey2, value: valueTitle, valueString: resultList[pKey2] });
              temp_value.push(
                {
                  name: dateArray[0].hiddenName,
                  value: [
                    moment(Number(resultList[pKey2])),
                    moment(Number(resultList[pKey])),
                  ],
                },
                {
                  name: pKey2,
                  value: moment(Number(resultList[pKey2])).format(dateFormat),
                },
                {
                  name: pKey,
                  value: moment(Number(resultList[pKey])).format(dateFormat),
                },
              )
              delete resultList[pKey2]
              delete resultList[pKey]
            } else if (dateArray.length > 0) {
              // 判断是否是时间格式
              valueTitle = dateArray[0].title
              pKey = dateArray[0].endTimeName ? dateArray[0].endTimeName : pKey
              const pKey2 = dateArray[0].startTimeName
                ? dateArray[0].startTimeName
                : ''
              temp_value.push(
                {
                  name: dateArray[0].hiddenName,
                  value: [moment(resultList[pKey2]), moment(resultList[pKey])],
                },
                {
                  name: pKey2,
                  value: resultList[pKey2],
                },
                {
                  name: pKey,
                  value: resultList[pKey],
                },
              )
            }
          }
          tempList.push({
            key: pKey,
            value: valueTitle,
            valueString: resultList[pKey],
          })
        }
        temp_value.push({ name: 'schemeName', value: resData.data.name }) // 方案名称
        temp_value.push({
          name: 'isDefault',
          vlaue: resData.data.isDefault === '1' ? true : false,
        }) // 是否默认

        console.log(temp_value, 'temp_value')
        const formArray = tempList.filter((item: any) => item.value !== '')
        dispatch(setAddFilterSchemeListAction(formArray))
        form_scheme.setFields(temp_value)
        form_scheme.setFieldsValue({
          isDefault: resData.data.isDefault === '1' ? true : false,
        })
        dispatch(setTableTitleAction('修改筛选方案'))
        dispatch(setSwitchVisibleAction(true))
        dispatch(setSchemeIdStringAction(param))
      }
    }
  }
  // 渲染item
  const renderFormItem = (key: string) => {
    const i = FormItemData(keyName).filter((item) => item.name === key)
    if (i.length === 0) {
      const timearr = FormItemData(keyName).filter(
        (item) => item.endTimeName === key,
      )
      if (timearr.length === 1) {
        const item = timearr[0]
        if (item.type === DateTime && item.hiddenName) {
          // 日期范围选择
          const startName = item.startTimeName
            ? item.startTimeName
            : 'contractStartDate'
          const endName = item.endTimeName
            ? item.endTimeName
            : 'contractEndDate'
          return (
            <Col {...valueColStyle} key={key}>
              <Form.Item
                name={item.hiddenName}
                {...ItemStyle}
                labelAlign="right"
              >
                <DatePicker.RangePicker
                  locale={locale}
                  getPopupContainer={() => document.body}
                  format={'YYYY-MM-DD'}
                  size="small"
                  placeholder={['请选择', '请选择']}
                  suffixIcon={<CalendarOutlined style={{ color: '#193274' }} />}
                  onChange={(value: any, formatString: [string, string]) =>
                    onChangeRangepicker(formatString, startName, endName, form)
                  }
                  {...inputStyle}
                />
              </Form.Item>
              <Form.Item
                name={item.startTimeName}
                noStyle
                style={{ display: 'none' }}
              >
                <Input hidden />
              </Form.Item>
              <Form.Item
                name={item.endTimeName}
                noStyle
                style={{ display: 'none' }}
              >
                <Input hidden />
              </Form.Item>
            </Col>
          )
        }
      }
    }
    if (i.length === 1) {
      const item = i[0]
      if (item.type === Hidden) {
        // 弹出选择数据
        const flag =
          SelectCheckBox.filter((typeItem) => typeItem === item.hiddenName)
            .length > 0
            ? true
            : false
        return (
          <Col {...valueColStyle} key={key}>
            <Form.Item name={item.hiddenName} {...ItemStyle} labelAlign="right">
              {flag ? (
                <Select
                  mode="multiple"
                  placeholder="请选择"
                  {...inputStyle}
                  allowClear
                  showSearch
                  getPopupContainer={() => document.body}
                  filterOption={(input, option: any) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  maxTagCount={2}
                  maxTagTextLength={4}
                >
                  {getPublicTableData(item.event)?.data.map((item) => (
                    <Select.Option key={item.code} value={item.code}>
                      {item.name}
                    </Select.Option>
                  ))}
                </Select>
              ) : (
                <Select
                  placeholder="请选择"
                  {...inputStyle}
                  allowClear
                  showSearch
                  getPopupContainer={() => document.body}
                  filterOption={(input, option: any) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {getPublicTableData(item.event)?.data.map((item) => (
                    <Select.Option key={item.code} value={item.code}>
                      {item.name}
                    </Select.Option>
                  ))}
                </Select>
              )}
            </Form.Item>
            <Form.Item name={item.name} noStyle style={{ display: 'none' }}>
              <Input hidden />
            </Form.Item>
          </Col>
        )
      }
      if (item.type === 'SizeQuery') {
        return (
          <Col {...valueColStyle} key={key}>
            <Form.Item name={item.name} labelAlign="right" {...ItemStyle}>
              <SizeQuery
                selectProps={{
                  getPopupContainer: () => document.body,
                  ...item?.sizeQuery?.customProps?.selectProps,
                }}
                inputProps={{
                  style: {
                    width: '100%',
                  },
                  ...item?.sizeQuery?.customProps?.InputProps,
                }}
              ></SizeQuery>
            </Form.Item>
          </Col>
        )
      }
      // 文本输入框
      return (
        <Col {...valueColStyle} key={key}>
          <Form.Item
            name={item.name}
            labelAlign="right"
            {...ItemStyle}
            getValueFromEvent={(event) =>
              event.target.value.trim()?.replace(/\s+/gi, ' ')
            }
          >
            <Input
              placeholder="请输入"
              suffix={
                <CloseCircleOutlined
                  className={Style.item}
                  onClick={() => onClickdel(item, form)}
                />
              }
              {...inputStyle}
            />
          </Form.Item>
        </Col>
      )
    }
  }
  // 渲染table 中的item
  const renderTableFormItem = (key: string, type: string, index: number) => {
    const i = FormItemData(keyName).filter((item) => item.name === key)
    if (i.length === 0) {
      const timearr = FormItemData(keyName).filter(
        (item) => item.endTimeName === key,
      )
      if (timearr.length === 1) {
        const item = timearr[0]
        if (item.type === DateTime && item.hiddenName) {
          // 日期范围选择
          const startName = item.startTimeName
            ? item.startTimeName
            : 'contractStartDate'
          const endName = item.endTimeName
            ? item.endTimeName
            : 'contractEndDate'

          return (
            <Col
              {...(type === '' ? valueColStyle : valueSchemeColStyle)}
              key={key + index.toString()}
            >
              <Form.Item
                name={item.hiddenName}
                {...ItemStyle}
                labelAlign="right"
                rules={[{ message: '请选择', required: true }]}
              >
                <DatePicker.RangePicker
                  locale={locale}
                  getPopupContainer={() => document.body}
                  format={'YYYY-MM-DD'}
                  size="small"
                  placeholder={['请选择', '请选择']}
                  suffixIcon={<CalendarOutlined style={{ color: '#193274' }} />}
                  onChange={(value: any, formatString: [string, string]) =>
                    onChangeRangepicker(
                      formatString,
                      startName,
                      endName,
                      form_scheme,
                    )
                  }
                  {...inputStyle}
                />
              </Form.Item>
              <Form.Item
                name={item.startTimeName}
                noStyle
                style={{ display: 'none' }}
              >
                <Input hidden />
              </Form.Item>
              <Form.Item
                name={item.endTimeName}
                noStyle
                style={{ display: 'none' }}
              >
                <Input hidden />
              </Form.Item>
              {renderAddOrDelete(index)}
            </Col>
          )
        }
      }
    }
    if (i.length === 1) {
      const item = i[0]
      if (item.type === Hidden) {
        // 弹出选择数据
        const flag =
          SelectCheckBox.filter((typeItem) => typeItem === item.hiddenName)
            .length > 0
            ? true
            : false

        return (
          <Col
            {...(type === '' ? valueColStyle : valueSchemeColStyle)}
            key={key + index.toString()}
          >
            <Form.Item
              name={item.hiddenName}
              {...ItemStyle}
              labelAlign="right"
              rules={[{ message: '请选择', required: true }]}
            >
              {flag ? (
                <Select
                  mode="multiple"
                  placeholder="请选择"
                  {...inputStyle}
                  allowClear
                  showSearch
                  getPopupContainer={() => document.body}
                  filterOption={(input, option: any) =>
                    option.children
                      ?.toLowerCase()
                      .indexOf(input?.toLowerCase()) >= 0
                  }
                  maxTagCount={2}
                  maxTagTextLength={4}
                >
                  {getPublicTableData(item.event)?.data.map((item) => (
                    <Select.Option key={item.code} value={item.code}>
                      {item.name}
                    </Select.Option>
                  ))}
                </Select>
              ) : (
                <Select
                  placeholder="请选择"
                  {...inputStyle}
                  allowClear
                  showSearch
                  getPopupContainer={() => document.body}
                  filterOption={(input, option: any) =>
                    option.children
                      ?.toLowerCase()
                      .indexOf(input?.toLowerCase()) >= 0
                  }
                >
                  {getPublicTableData(item.event)?.data.map((item) => (
                    <Select.Option key={item.code} value={item.code}>
                      {item.name}
                    </Select.Option>
                  ))}
                </Select>
              )}
            </Form.Item>
            <Form.Item name={item.name} noStyle style={{ display: 'none' }}>
              <Input hidden />
            </Form.Item>
            {renderAddOrDelete(index)}
          </Col>
        )
      }
      if (item.type === 'SizeQuery') {
        return (
          <Col {...valueSchemeColStyle} key={key}>
            <Form.Item name={item.name} labelAlign="right" {...ItemStyle}>
              <SizeQuery
                style={{
                  width: '100%',
                }}
                selectProps={{
                  getPopupContainer: () => document.body,
                  ...item?.sizeQuery?.customProps?.selectProps,
                }}
                inputProps={{
                  style: {
                    width: '100%',
                  },
                  ...item?.sizeQuery?.customProps?.inputProps,
                }}
              ></SizeQuery>
            </Form.Item>
            {renderAddOrDelete(index)}
          </Col>
        )
      }
      // 文本输入框
      return (
        <Col {...valueSchemeColStyle} key={key + index.toString()}>
          <Form.Item
            name={item.name}
            labelAlign="right"
            {...ItemStyle}
            getValueFromEvent={(event) =>
              event.target.value.trim()?.replace(/\s+/gi, ' ')
            }
            rules={[{ message: '请输入', required: true }]}
          >
            <Input
              placeholder="请输入"
              maxLength={50}
              suffix={
                <CloseCircleOutlined
                  className={Style.item}
                  onClick={() => onClickdel(item, form_scheme)}
                />
              }
              {...inputStyle}
            />
          </Form.Item>
          {renderAddOrDelete(index)}
        </Col>
      )
    }
    // }
  }
  function renderAddOrDelete(index: number) {
    return index === addSchemeList.length - 1 ? (
      <div style={{ position: 'absolute', right: '0px', top: '10px' }}>
        {addSchemeList.length !== formSelectList.length ? (
          <PlusCircleOutlined
            style={{ fontSize: '20px', marginRight: '10px' }}
            onClick={() => onAddLine()}
          />
        ) : null}
        {addSchemeList.length !== 1 ? (
          <MinusCircleOutlined
            style={{ fontSize: '20px', marginRight: '10px' }}
            onClick={() => onDeleteLine(index)}
          />
        ) : null}
      </div>
    ) : null
  }

  // 方案表格头
  const listColumn = [
    {
      key: 'erpCode',
      title: '筛选条件',
      onHeaderCell: () => ({
        className: Style['table-header'],
      }),
      render: (text: any, record: any, index: any) => {
        const selectListItem = addSchemeList.map((item) => item.value)
        const filteredOptions = formSelectList.filter(
          (o) => !selectListItem.includes(o.value),
        )
        return (
          <div>
            <Select
              placeholder="请选择"
              {...inputStyle}
              allowClear
              showSearch
              getPopupContainer={() => document.body}
              filterOption={(input, option: any) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              onSelect={(value: any) => {
                // 根据选择的内容更换旁边col的展示内容

                const result = filterFormItem(value)
                addSchemeList[index].key = result.key
                addSchemeList[index].value = result.des
                dispatch(setAddFilterSchemeListAction(addSchemeList))
              }}
              value={addSchemeList[index].value}
            >
              {filteredOptions.map((item) => (
                <Select.Option key={item.key} value={item.key}>
                  {item.value}
                </Select.Option>
              ))}
            </Select>
          </div>
        )
      },
    },
    {
      key: 'name',
      title: '值',
      textAlign: 'center',
      onHeaderCell: () => ({
        className: Style['table-header'],
      }),
      onCell: () => ({
        className: Style['table-td'],
      }),
      render: (text: any, record: any, index: any) => {
        return (
          <div style={{ width: '100%', display: 'flex' }}>
            {renderTableFormItem(addSchemeList[index].key, '_scheme', index)}
          </div>
        )
      },
    },
  ]

  // input 样式
  const inputStyle = {
    style: {
      height: '24px',
      lineHeight: '24px',
      fontSize: '12px',
      width: '100%',
      cursor: 'pointer',
    },
  }
  // input 样式
  // Item样式
  const ItemStyle = {
    style: { marginBottom: '0px' },
    wrapperCol: { span: 20 },
  }
  //  col 样式
  const colStyle = {
    style: { padding: '10px 5px 5px 5px' },
    xl: { span: hideScheme ? 6 : 3 }, // ≥1200px
    lg: { span: 12 }, // 大桌面显示器  ≥992px)
    md: { span: 12 }, // 桌面显示器 ≥768px)
    sm: { span: 24 }, // 平板 ≥576px
  }
  const valueColStyle = {
    style: { padding: '10px 5px 5px 5px' },
    xl: { span: hideScheme ? 8 : 6 }, // ≥1200px
    lg: { span: 12 }, // 大桌面显示器  ≥992px)
    md: { span: 12 }, // 桌面显示器 ≥768px)
    sm: { span: 24 }, // 平板 ≥576px
  }
  const valueSchemeColStyle = {
    style: { padding: '10px 5px 5px 5px' },
    xl: { span: 24 }, // ≥1200px
    lg: { span: 12 }, // 大桌面显示器  ≥992px)
    md: { span: 12 }, // 桌面显示器 ≥768px)
    sm: { span: 24 }, // 平板 ≥576px
  }
  return (
    <div>
      <Form
        // ref={currentForm}
        ref={currentRef}
        form={form}
        className={Style.searchform}
        name="searchForm"
        colon={false}
        onFinish={onHandleSearch}
      >
        <div className={Style.searchbox}>
          <div className={Style['condition-row']}>
            <div className={Style.screen}>
              <CustomeIcon
                type="icon-fangdajing"
                style={{ fontSize: '16px' }}
              />
              <span>条件:</span>
            </div>
            <div className={`${Style.content}`}>
              <div ref={contentRef}>
                <Row gutter={8} style={{ margin: '0 0 0 0' }}>
                  {/* {默认为下拉选择框，下拉数据为外部传入} */}
                  {/* <div style={{width:'160px'}}> */}
                  <Col {...colStyle}>
                    <Select
                      placeholder="请选择"
                      {...inputStyle}
                      allowClear
                      showSearch
                      getPopupContainer={() => document.body}
                      filterOption={(input, option: any) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      onSelect={(value: any) => {
                        // 根据选择的内容更换旁边col的展示内容
                        const result = filterFormItem(value)
                        dispatch(
                          setColKeyAction({
                            key: result.key ? result.key : '',
                            des: result.des,
                          }),
                        )
                      }}
                      value={showColKeyDes}
                    >
                      {formSelectList.map((item) => (
                        <Select.Option key={item.key} value={item.key}>
                          {item.value}
                        </Select.Option>
                      ))}
                    </Select>
                  </Col>
                  {renderFormItem(showColKey)}
                  <div className={Style.toolbox}>
                    <Button
                      type="primary"
                      size="small"
                      htmlType="submit"
                      style={{
                        color: '#FFFFFF',
                        background: '#3C44D3',
                        borderColor: '#3C44D3',
                        marginRight: '10px',
                      }}
                      className={Style.toolBtn}
                    >
                      查询
                    </Button>
                    <Button
                      type="primary"
                      ghost
                      size="small"
                      // htmlType="reset"
                      style={{ color: '#3C44D3', borderColor: '#3C44D3' }}
                      className={Style.toolBtn}
                      onClick={(e) => {
                        stopAllPropagation(e)
                        onHandleReset?.()
                      }}
                    >
                      重置
                    </Button>
                  </div>
                </Row>
              </div>
            </div>
          </div>
          <div className={Style['scheme-row']} hidden={hideScheme}>
            <div className={Style.screen}>
              <CustomeIcon
                type="icon-fangdajing"
                style={{ fontSize: '16px' }}
              />
              <span>方案:</span>
            </div>
            <div className={`${Style.content}`}>
              <div ref={contentRef} className={`${Style.schemeList}`}>
                {/* <Row gutter={8} style={{ margin: '0 0 0 0' }}> */}
                {schemeList.map((item: schemeObj) => (
                  <div
                    key={item.id}
                    className={`${
                      item.isSelect ? Style.defaultScheme : Style.scheme
                    }`}
                    onClick={() => onClickSelectScheme(item)}
                  >
                    {item.id !== 'default' ? (
                      <div className={Style['scheme-item']}>
                        {item.isDefault ? (
                          <CheckCircleOutlined
                            style={{
                              position: 'relative',
                              left: '-15px',
                              top: '-14px',
                            }}
                          />
                        ) : null}
                        <span className={Style['selectSpan']}>
                          {item.title}
                        </span>

                        <img
                          className={Style.spanItem}
                          src={imgDelete}
                          onClick={(event) => {
                            event.stopPropagation()
                            event.nativeEvent.stopImmediatePropagation()
                            onClickDelScheme(item.id)
                          }}
                          alt=""
                        ></img>
                        <img
                          className={Style.updateItem}
                          src={imgUpdate}
                          onClick={(event) => {
                            event.stopPropagation()
                            event.nativeEvent.stopImmediatePropagation()
                            onEditSchemeAciton(item.id)
                          }}
                          alt=""
                        ></img>
                      </div>
                    ) : (
                      <span className={Style['selectSpan']}>{item.title}</span>
                    )}
                  </div>
                ))}
                <div className={Style.toolbox}>
                  <Button
                    type="primary"
                    size="small"
                    style={{
                      color: '#3C44D3',
                      background: '#FFFFFF',
                      borderColor: '#3C44D3',
                      marginRight: '10px',
                    }}
                    onClick={onAddSchemeAction}
                    className={Style.toolBtn}
                  >
                    添加
                  </Button>
                  <Button
                    type="primary"
                    size="small"
                    style={{
                      color: '#3C44D3',
                      background: '#FFFFFF',
                      borderColor: '#3C44D3',
                    }}
                    onClick={onSetDefaultSchemeAction}
                    className={Style.toolBtn}
                  >
                    设为默认
                  </Button>
                </div>
                {/* </Row> */}
              </div>
            </div>
          </div>
        </div>
      </Form>
      <CustomModal
        width={700}
        open={visible}
        title={tableTitle}
        footer={false}
        modalCancel={onCancel}
      >
        <Form
          form={form_scheme}
          className={Style.searchform}
          colon={false}
          onFinish={onHandleSave}
          onReset={onHandleReset}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              margin: '10px 0 10px 0',
            }}
          >
            <span>方案名称：</span>
            <Form.Item
              name="schemeName"
              style={{ margin: '4px 0 0 10px' }}
              rules={[{ message: '请输入方案名称', required: true }]}
            >
              <Input
                size="small"
                placeholder="请输入"
                style={{ width: '350px' }}
                onChange={(e) =>
                  form_scheme.setFieldsValue({ schemeName: e.target.value })
                }
                maxLength={30}
              />
            </Form.Item>

            <Form.Item
              name="isDefault"
              style={{ margin: '4px 0 0 10px' }}
              valuePropName="checked"
            >
              <Checkbox>设为默认</Checkbox>
            </Form.Item>
          </div>
          <Table
            rowKey="id"
            tableLayout="fixed"
            className={Style['table-box']}
            size="small"
            dataSource={addSchemeList}
            loading={false}
            columns={listColumn}
            pagination={false}
          ></Table>
          <div
            style={{
              textAlign: 'center',
              borderTop: '1px solid #F8F8F8',
              paddingTop: '10px',
            }}
          >
            <Button
              type="primary"
              size="middle"
              htmlType="submit"
              style={{ backgroundColor: '#193274' }}
            >
              保存
            </Button>
          </div>
        </Form>
      </CustomModal>

      {/* 筛选条件 */}
      <CustomModal
        width={350}
        open={confirmVisible}
        title={'是否确定删除该方案'}
        modalCancel={onCancel}
        modalSubmit={onConfirmDeleteScheme}
      ></CustomModal>
    </div>
  )
}

export default Search
